import moment from 'moment-timezone';

interface TimeLeft {
  hasExpired?: boolean;
  isInvalidDate?: boolean;
  days?: number;
  hours?: number;
  minutes?: number;
}

export const getTrialTimeLeft = (trialEndsAt: string): TimeLeft => {
  const endDate = moment.utc(trialEndsAt);
  if (!endDate.isValid()) {
    return { isInvalidDate: true };
  }

  const now = moment.utc();

  if (now.isAfter(endDate)) {
    return { hasExpired: true };
  }
  // Calculating the full 24-hour periods for days left based on the beginning of each day to resolve any off-by-one error.
  const daysLeft = endDate.clone().startOf('day').diff(now.clone().startOf('day'), 'days');

  if (now.isSame(endDate, 'day')) {
    const hoursLeft = endDate.diff(now, 'hours') % 24;
    const minutesLeft = endDate.diff(now, 'minutes') % 60;
    return { days: daysLeft, hours: hoursLeft, minutes: minutesLeft };
  }

  return { days: daysLeft };
};
